var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LLTabs2',{staticClass:"notifications-panel-tabs",attrs:{"items":_vm.tabs,"small":""},on:{"change":_vm.onChange},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }